import { PlatformDependent } from '@/components/PlatformDependent'

import { TeamViewDDE } from './TeamView.dde'

const TeamView = () => (
  <>
    <PlatformDependent dde>
      <TeamViewDDE />
    </PlatformDependent>
  </>
)

export default TeamView
